import './que-plugin.scss';

export default () => Component(function ($context) {
	return $context.select('.que-plugin');
}, function ($que, self) {
	const $openFormBtn = $que.find('.que-plugin__btn');
	const $form = $que.find('#que-plugin-faq-form');
	$que.data('component', self);

	$.extend(self, {
		$formClone: '',
		initEventListeners: function () {
			$openFormBtn.on('click', function() {
				self.openModal();
			})
		},
		openModal: function() {
			const $content = $($openFormBtn.data('modal-content'));
			$content.find('.c-modal__content').html(self.$formClone);

			ModalUtil.openContent($content, function() {
				$('#que-faq-form-submit').attr('disabled', false);
				$.queForm('#que-plugin-faq-form', function(response, dat) {
					$content.find('.review-form__title').text('Спасибо за обращение!');
					dat.replaceWith('<div class="que-result-inner"><div class="que-result-content">В ближайшее время мы ответим на Ваш вопрос</div></div>');
					window.setTimeout(function() {
						ModalUtil.close();
					}, 2000);
				});
			}, null, {
				enableEscapeKey: false
			});
		},
		init: function() {
			self.$formClone = $form.clone();
			$form.remove();
		}
	});

	self.init();
	self.initEventListeners();
})
